import React from 'react';
import Header from "./Header.js";
import Hero from "./Hero.js";
import Footer from "./Footer.js";


function ChooseMode() {
  return (
    <div>
      <Header/>
      <Hero/>
      <Footer />
    </div>
  );
}

export default ChooseMode;
